export const RAGE_LOCK_CLASS = 'js-ar-lock';
const RAGE_LOCK_DISABLED_CLASS = 'js-ar-lock-disabled';
const RAGE_LOCK_TIMEOUT = 3000; // 3 seconds


export function setCookie(name, value, days) {
  var expires;
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = `expires=${date.toGMTString()};`;
  } else {
    expires = '';
  }
  const hostname = location.hostname;
  document.cookie = `${name}=${value};path=/;${expires}domain=.${hostname}`;
}

export function getCookie(name) {
  // Returns the value of the cookie with the given name.
  const cookies = document.cookie
    ? document.cookie.split('; ').reduce((acc, cookieStr) => {
        const [key, ...valParts] = cookieStr.split('=');
        acc[decodeURIComponent(key)] = decodeURIComponent(valParts.join('='));
        return acc;
      }, {})
    : {};
  return cookies[name] || '';
}

export function getUrlParamByName(name, url) {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, '\\$&');
  var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

export function localizedFormatMoney(value, decimal_places) {
  return value.formatMoney(
    decimal_places,
    '',
    get_format('THOUSAND_SEPARATOR'),
    get_format('DECIMAL_SEPARATOR'),
  );
}

export function isMobileWidth() {
  return $(window).width() < 768;
}

export function inputIntValue($elem) {
  return parseInt($elem.val()) || 0;
}

// Meta marketing api stuff, details available here:
// https://developers.facebook.com/docs/marketing-api/conversions-api/parameters/fbp-and-fbc

function fbc() {
  // Check if fbc cookie is present and if it matches the fbclid query parameter.
  // If not, create a new fbc cookie.
  // TLDR: ensures fbc (fbclid) cookie is present and up-to-date.
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  let c = getCookie('_fbc');
  let fbclid = urlParams.get('fbclid');

  if (c && (!fbclid || c.split('.').pop() === fbclid)) {
    return c;
  }

  if (!fbclid) {
    return;
  }

  let fbc = `fb.1.${Date.now()}.${fbclid}`;
  setCookie('_fbc', fbc, 90);
  return fbc;
}

function fbp() {
  // Check if fbp cookie is present. If not, create a new fbp cookie.
  // TLDR: ensures fbp (random id) cookie is present and up-to-date.
  let c = getCookie('_fbp');
  if (c) {
    return c;
  }

  let fbp = `fb.1.${Date.now()}.${Math.floor(Math.random() * 9000000000) + 1}`;
  setCookie('_fbp', fbp, 90);
  return fbp;
}

function metaEventsWatcher(debug = false) {
  if (!('Proxy' in window)) {
    console.warn("Your browser doesn't support Proxies.");
    return;
  }

  // Checks if fb meta consent is granted (retargeting purpose).
  function hasGrantedKlaroConsent(value) {
    // Checks if klaro consent is granted for the given value.
    const KLARO_COOKIE_NAME = 'cookies_consent'; // Don't import from klaro_config.js to avoid circular dependency.

    // console.log('Checking Klaro consent for: ' + value);
    const cookies_consent = JSON.parse(getCookie(KLARO_COOKIE_NAME) || '{}');
    // console.log(cookies_consent);
    const retval = cookies_consent[value] === true;
    // console.log('Klaro saved consent for ' + value + ': ' + retval);
    return retval;
  }

  const KLARO_REQUIRED_CONSENT = 'meta_conversion_api';
  if (!hasGrantedKlaroConsent(KLARO_REQUIRED_CONSENT)) {
    console.warn('Meta events are not enabled in cookies consent.');
    return;
  }

  function sme_send(pixel_id, data) {
    const base_url = __CLOUDFLARE_WORKER_URL__;
    const dest_url = base_url + '/fb/' + pixel_id;
    const body = {
      'encrypted_data': data,
      'event_time': Math.floor(Date.now() / 1000),
      'fbc': fbc(),
      'fbp': fbp(),
    };

    if (debug) {
      console.log('Would send event: ', { dest_url, body });
      console.log('Dest url: ', {dest_url});
      console.log('body: ', {body});
      return;
    };

    fetch(dest_url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Origin': __FULL_WEBSITE_URL__,
      },
      body: JSON.stringify(body),
    })
      .then(response => response)
      .catch(error => {
        console.error('Failed to send data to cf worker');
      });
  }

  window.meq = new Proxy(window.meq, {
    set: function(target, property, value, receiver) {
      // target: meq array object holding events
      // property: index of the array element
      // value: the new item being added to the array (consists of pixel_id and data)
      target[property] = value;
      if (property !== 'length') sme_send(value[0], value[1]);
      return true;
    },
  });

  while(window.meq.length) {
    let event = window.meq.shift();
    sme_send(event[0], event[1]);
  }
}
metaEventsWatcher(false);

export function antiRageClick($elem) {
  // Hard-lock the form for some time after submission attempt.
  // Temporary code to check for the source of double form submissions.
  // TODO: Remove after the issue is resolved.

  // Prevents locking $elem if has `RAGE_LOCK_DISABLED_CLASS` class.
  if ($elem.hasClass(RAGE_LOCK_DISABLED_CLASS)) {
    return false;
  }

  if ($elem.hasClass(RAGE_LOCK_CLASS)) {
    return true;
  } else {
    $elem.addClass(RAGE_LOCK_CLASS);
    // auto remove lock after some time
    setTimeout(function() {
      $elem.removeClass(RAGE_LOCK_CLASS);
    }, RAGE_LOCK_TIMEOUT);
    return false;
  }
}

export function AdCampaignDataToCookie(saveCookie = false) {
  // console.log('AdCampaignDataToCookie called');
  // Extracts UTM campaign data from the current url query parameters
  // and optionally saves them in cookie for further tracking.
  // DEVS: Ensure that 'analytics' cookie permission has been granted
  // before calling this method with `true` arg.

  var keys = [
      'utm_source',
      'utm_medium',
      'utm_campaign',
      'utm_term',
      'utm_content',
    ],
    google_regexp = '^https?://www.google.(.+)?',
    max_value_length = 50,
    key,
    value,
    campaign_data = {};

  function hasKeys(dict) {
    return Object.keys(dict).length !== 0;
  }

  for (var i = 0; i < keys.length; i++) {
    key = keys[i];
    value = getUrlParamByName(key);
    if (value) {
      campaign_data[key] = value.substring(0, max_value_length);
    }
  }
  if (
    !hasKeys(campaign_data) &&
    document.referrer.toLowerCase().match(google_regexp)
  ) {
    campaign_data = {
      utm_source: 'google',
      utm_medium: 'organic',
    };
  }
  if (hasKeys(campaign_data)) {
    campaign_data['timestamp'] = Date.now() / 1000; // This division is needed be compatible with python timestamps.
    if (saveCookie) {
      // console.log('Saving campaign data to cookie:', campaign_data);
      const cookieLifetime = 30; // days
      setCookie('acd', JSON.stringify(campaign_data), cookieLifetime);
    }
  }
  return campaign_data;
}

export function loadScript(url, callback, fail_callback) {
  jQuery
    .ajax({
      url: url,
      dataType: 'script',
      async: true,
    })
    .done(function(script, textStatus) {
      if (typeof callback === 'function') {
        callback();
      }
    })
    .fail(function(jqxhr, settings, exception) {
      if (typeof fail_callback === 'function') {
        fail_callback();
      }
    });
}

export function initTargetClick() {
  const selector = '.js-target-click';
  const redirectSelector = '.js-target-click-redirect';

  $(document).on('click touchend', selector, function(e) {
    // Allows click on one element to trigger click on another element.
    // Links don't work with click event,
    // so an extra class `js-target-click-redirect` needs to be added to the target element,
    // which will redirect to the link instead of triggering click event.
    e.stopPropagation();
    e.preventDefault();

    const $this = $(this);
    const $target = $($this.data('target'));
    if ($target.is(redirectSelector)) {
      window.location.href = $target.attr('href');
    } else {
      $target.trigger('click');
    }
  });
}
